import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/services/alert.service';
import { PreCheckoutService } from 'src/app/services/pre-checkout.service';
import { PreCheckoutQuery } from 'src/app/state/pre-checkout.query';
import { DisplayLoginComponents, PreCheckoutLoginService } from '../pre-checkout-login.service';

@Component({
  selector: 'app-pre-checkout-login-sms',
  templateUrl: './pre-checkout-login-sms.component.html',
  styleUrls: ['./pre-checkout-login-sms.component.css']
})
export class PreCheckoutLoginSmsComponent implements OnInit {

  tentativa: number = 0;
  tentativaEnvioSMS: number = 0;
  codigoSMS: number;
  translation: any;
  cpf: string = null;
  phone: string = null;
  preCheckoutFormSMS = this.formBuilder.group({
    sms: ''
  });

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private preCheckoutQuery: PreCheckoutQuery,
    private preCheckoutService: PreCheckoutService,
    private translate: TranslateService,
    private loginService: PreCheckoutLoginService
  ) { }

  validFormSMS() {
    return this.preCheckoutFormSMS.valid;
  }

  validSMS() {
    return this.preCheckoutFormSMS.value.sms.length==0 ||
    this.preCheckoutFormSMS.value.sms.length == 6;
  }

  defineAlertMessages(message, title, classAlert, showAlert: boolean = true){
    this.tentativa = this.alertService.defineAlertMessage(message, title, classAlert, showAlert, this.tentativa);
  }

  internalError(err){
    this.alertService.alertDanger(this.translation.internalError, null);
    console.log(err)
  }

  generateRandomNumber(): number{
    return Math.floor(100000 + Math.random() * 900000);
  }

  onSubmit(): void {
    if(this.validFormSMS())
    {
      if(this.preCheckoutFormSMS.value.sms != this.codigoSMS){
        this.defineAlertMessages("Código de acesso inválido, tente novamente!", null, "alert-warning");
      }
      else{
        if(this.cpf && this.phone){
          this.preCheckoutService.updatePhone(this.cpf, this.phone)
          .subscribe(
            (result) => {
              if(result){
                this.defineAlertMessages("Número de celular atualizado com sucesso, prossiga com a validação do login", "", "alert-success");
                this.loginService.setDisplay(new DisplayLoginComponents(false, false, true));
              }
              else{
                this.defineAlertMessages("Erro ao tentar atualizar número de celular, tente novamente!", "", "alert-danger");
              }
            },
            (err) => {
              this.internalError(err);
            }
          );
        }
        else{
          this.alertService.alertDanger("Erro ao tentar atualizar número de celular, tente novamente!", null);
        }
      }
    }
  }

  validaEnvioSMS(){
    let message: string = this.tentativaEnvioSMS < 2 ? "" : "Aguarde para tentar um novo reenvio de SMS!";

    if(this.tentativaEnvioSMS<=2)
      this.sendSMS();

    this.tentativaEnvioSMS = this.alertService.defineAlertMessage(message, null, "alert-warning", !!message, this.tentativaEnvioSMS);
  }

  sendSMS()
  {
    this.codigoSMS = this.generateRandomNumber();

    let message = "Informe o codigo de seguranca " + this.codigoSMS.toString();
    message+=" para atualizacao do seu celular em nossa base de dados (TeleConsult-Buonny)\n";
    message+="Atualizacao cadastral solicitada atraves do aplicativo pre-checkout."

    this.preCheckoutService.sendSMS(this.phone, message)
    .subscribe(
      (result) => {
        if(!result.success){
          this.alertService.alertDanger("Erro ao tentar enviar SMS", null);
        }
      },
      (err) => {
        this.internalError(err);
      }
    );
  }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();
    
    this.preCheckoutQuery.cpf$.subscribe((cpf)=>{
      this.cpf = cpf;
    });
    this.preCheckoutQuery.phone$.subscribe((phone)=>{
      this.phone = phone;
    });

    this.translate.get("preCheckout").subscribe((res) => {
      this.translation = res;
    });

    this.sendSMS();
  }

}